/** All the possible headers for background tasks table. */
export let BackgroundTasksTableHeaders = /*#__PURE__*/function (BackgroundTasksTableHeaders) {
  /** The Background Task icon */
  BackgroundTasksTableHeaders["icon"] = "Icon";
  /** The type of background task */
  BackgroundTasksTableHeaders["fileName"] = "File name";
  /** The status of background task */
  BackgroundTasksTableHeaders["status"] = "Status";
  /** The progress of background task */
  BackgroundTasksTableHeaders["progress"] = "Progress";
  /** The created date and time of background task */
  BackgroundTasksTableHeaders["created"] = "Created";
  /** The updated date and time of background task */
  BackgroundTasksTableHeaders["updated"] = "Updated";
  /** Background task options */
  BackgroundTasksTableHeaders["options"] = "Options";
  return BackgroundTasksTableHeaders;
}({});